export default __webpack_public_path__ + "static/media/Group39690.16f7b976.png";